import { Component, OnDestroy, OnInit, DOCUMENT, inject } from '@angular/core';
import { AlertLength, AlertService, BsCommon } from '@bsquare/angular-common';
import { AppConfigService } from 'app/services/app-config.service';
import { TitleService } from 'app/services/title.service';
import { Subscription } from 'rxjs';
import { AuthService } from 'services/auth.service';
import { ExportsService } from 'services/exports.service';
import { NavbarComponent } from '../navbar/navbar.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [BsCommon, NavbarComponent, RouterOutlet],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly document = inject<Document>(DOCUMENT);

  private readonly titleService = inject(TitleService);
  private readonly exportsService = inject(ExportsService);
  private subscriptions: Subscription[] = [];
  private readonly alertService = inject(AlertService);
  public authService = inject(AuthService);
  public loggedIn = false;
  protected color = AppConfigService.settings.color;

  public ngOnInit(): void {
    this.titleService.init();

    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');

    style.id = 'color';
    style.rel = 'stylesheet';
    style.href = `${this.color}.css`;
    head.appendChild(style);

    this.subscriptions.push(
      this.exportsService.getExportCompletions().subscribe((completions) => {
        if (completions.length > 0) {
          const names = completions.map((completion) => completion.name).join(', ');
          this.alertService.show({
            type: 'info',
            message: `The following export${
              completions.length > 1 ? 's have' : ' has'
            } completed: `,
            links: [
              {
                path: '/manage/exports',
                text: names,
              },
            ],
            autoClose: AlertLength.Medium,
          });
        }
      }),
    );
    this.subscriptions.push(
      this.authService.loggedIn.subscribe((loggedIn) => (this.loggedIn = loggedIn)),
    );
  }

  public ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions = [];
  }
}
